import type { BrandProfile, BrandProfileInput } from '../models/brand';
import { api, PANEL_API } from './api-client';

class BrandService {
  async list(): Promise<BrandProfile[]> {
    const res = await api.get<{ brands: BrandProfile[] }>(`${PANEL_API}/brands`);
    return res.brands;
  }

  async create(input: BrandProfileInput): Promise<BrandProfile> {
    return api.post<BrandProfile>(`${PANEL_API}/brands`, input);
  }

  async update(name: string, input: BrandProfileInput): Promise<BrandProfile> {
    return api.put<BrandProfile>(`${PANEL_API}/brands/${encodeURIComponent(name)}`, input);
  }

  async remove(name: string): Promise<void> {
    await api.delete(`${PANEL_API}/brands/${encodeURIComponent(name)}`);
  }

  /** Kurulum scriptini sunucuda `sh -n` ile sözdizimi denetiminden geçirir. */
  async validateScript(script: string): Promise<{ ok: boolean; error?: string }> {
    return api.post<{ ok: boolean; error?: string }>(`${PANEL_API}/brands/validate-script`, {
      script,
    });
  }
}

export const brands = new BrandService();
